export const ConversationIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
        <g clip-path="url(#clip0_2830_257)">
            <path d="M14.7812 3.21875H13.9555C13.6068 1.5095 12.0918 0.21875 10.2812 0.21875H4.28125C2.2135 0.21875 0.53125 1.901 0.53125 3.96875V13.6093C0.53125 14.2048 0.8575 14.7492 1.38175 15.0297C1.62025 15.158 1.882 15.221 2.143 15.221C2.455 15.221 2.76625 15.1302 3.0355 14.951L5.248 13.4757C5.76625 14.927 7.15375 15.9688 8.78125 15.9688H13.054L16.027 17.951C16.297 18.131 16.6075 18.2218 16.9195 18.2218C17.1805 18.2218 17.4415 18.158 17.6807 18.0297C18.2057 17.7492 18.5312 17.2048 18.5312 16.6092V6.96875C18.5312 4.901 16.849 3.21875 14.7812 3.21875ZM2.20375 13.703C2.1895 13.712 2.1475 13.739 2.08975 13.7083C2.0305 13.6768 2.0305 13.6265 2.0305 13.61V3.96875C2.0305 2.72825 3.04 1.71875 4.2805 1.71875H10.2805C11.521 1.71875 12.5305 2.72825 12.5305 3.96875V9.21875C12.5305 10.4593 11.521 11.4688 10.2805 11.4688H5.7805C5.53525 11.4688 5.37475 11.588 5.35675 11.6L2.20375 13.703ZM17.0312 16.61C17.0312 16.6257 17.0312 16.6768 16.972 16.7083C16.9128 16.739 16.8722 16.712 16.8587 16.703L13.6975 14.5947C13.5745 14.513 13.4298 14.4688 13.2812 14.4688H8.78125C7.80325 14.4688 6.97 13.8418 6.66025 12.9688H10.2812C12.349 12.9688 14.0312 11.2865 14.0312 9.21875V4.71875H14.7812C16.0218 4.71875 17.0312 5.72825 17.0312 6.96875V16.61Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_2830_257">
            <rect width="18" height="18" fill="white" transform="translate(0.53125 0.21875)"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
